import PDFList from "components/pdfList";
import SEO from "components/SEO";
import { fetchPost } from "functions";
import useTranslation from "translations/hooks/useTranslation";

const TechnicalOffice = ({ pageData, lang }) => {
  const { t } = useTranslation();
  return (
   <>
        <SEO title={t("technicalOffice")} description={t("technicalOfficeDesc")} />
    <PDFList 
      lang={lang}
      pageData={pageData}
      title1={"monthlyReports"}
      title={'technicalOffice'}
      breadcrumb={"monthlyReports"}
      desc={"technicalOfficeDesc"}
    />
    </>
  );
};

export default TechnicalOffice;

export async function getServerSideProps(context) {
  let { lang } = context?.query;

  let pageData = await fetchPost({
    apiName: `oea-technical-office/get`,
  });

  return {
    props: {
      lang,
      pageData: pageData?.response,
    },
  };
}
